<ng-container>
  <div>
    <div class="message-container">
      <h2>Privacy Policy Update</h2>
      <p>
        We have updated our <a class="privacy" href="https://www.myfuturechoice.com/privacy-policy-for-students/" target="_blank">Privacy Notice</a>, and the changes came into effect on August 18th, 2021.  Here is a brief summary of the key updates:
      </p>
      <ul>
        <li>We have adjusted the length of time that we will store your data, and will only keep it for a maximum of 10 years, depending on the date when you registered your MyUniChoices account</li>
      </ul>
      <p>
        Your continued use of MyFutureChoice services after August 18th, 2021 will be subject to this updated Privacy Notice.  If you object to the updated terms of our <a class="privacy" href="https://www.myfuturechoice.com/privacy-policy-for-students/" target="_blank">Privacy Notice</a> and/or wish to close your account please contact <strong>customersupport@myfuturechoice.com</strong>.
      </p>
      <p>
        MyFutureChoice is committed to safeguarding your personal information, so please take a moment to read through this updated <a class="privacy" href="https://www.myfuturechoice.com/privacy-policy-for-students/" target="_blank">Privacy Notice</a> and ensure you understand the changes.
      </p>
      <div class="actions privacy-ok">
        <button class="form-control btn margin-top" (click)="continue()">OK</button>
        <br /><br />
        <a class="cancel_link" href="#" (click)="logout()">Logout</a>
      </div>
    </div>
  </div>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/components/legal/privacy-policy-update/privacy-policy-update.component.html